import {
  Box,
  Button,
  Chip,
  Stack,
  styled,
  Text,
} from '@ltvco/refresh-lib/theme';

export const OverviewInsightsWrap = styled(Box)({
  '&:has(#property-professional-insights) #property-overview': {
    borderBottom: 'none',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    paddingBottom: 0,
  },
});

export const InsightsEmbed = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderTop: 'none',
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
  padding: theme.spacing(2.5),
  paddingTop: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    border: 'none',
    borderRadius: 0,
  },
}));

export const InsightsCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2.5),
  paddingBottom: 0,
  overflow: 'hidden',
}));

export const InsightsHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const TagChip = styled(Chip)(({ theme }) => ({
  height: 32,
  borderRadius: 100,
  backgroundColor: '#eef1fa',
  color: theme.palette.text.primary,
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: '0.16px',
  '& .MuiChip-icon': {
    color: theme.palette.primary.main,
    fontSize: 16,
    marginLeft: theme.spacing(1),
    marginRight: 0,
  },
  '& .MuiChip-label': {
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(1.5),
    lineHeight: '18px',
  },
  '&:hover': {
    backgroundColor: '#eef1fa',
  },
}));

export const DetailsSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.background.default,
  marginLeft: theme.spacing(-2.5),
  marginRight: theme.spacing(-2.5),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const AccordionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  userSelect: 'none',
  padding: theme.spacing(2),
}));

export const InsightsList = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const InsightRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-of-type': {
    borderBottom: 'none',
  },
}));

export const InsightIconCircle = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  borderRadius: '100%',
  width: 28,
  height: 28,
  minWidth: 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const InsightBody = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(5),
}));

export const ViewInReportLink = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.5, 0.625),
  minWidth: 'auto',
  textTransform: 'none',
  fontWeight: 700,
  fontSize: 13,
  lineHeight: '22px',
  letterSpacing: '0.46px',
  color: theme.palette.primary.main,
  flexShrink: 0,
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
}));

export const SkeletonBlock = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.spacing(1),
}));

export const DisclaimerText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 12,
  fontFamily: 'Lato',
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const LeadScoreCtaRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
  flexWrap: 'wrap',
}));
